import * as STD from '@emersya/mpa-std-lib';

import CM                                  from '@emersya/mpa-components-manager-lib';
import { Block, Image }         from '@emersya/mpa-components-lib';
import ViewerComponent, { NS as ViewerNS } from '../../../viewer/Viewer/Viewer';


export interface IStandingPartitionsHeadsPrestigeComponentConfiguration extends Block.Configuration {
	text : STD.translationsManager.TranslationMapping;
};

export class StandingPartitionsHeadsPrestigeComponent extends Block.Component {
	static override initialize() {
		super.initialize();
	};

	readonly plannerCategory! : ViewerComponent.ProductCategory;
	viewerNodeLeft : ViewerComponent.ProductInstance | null = null;
	viewerNodeRight : ViewerComponent.ProductInstance | null = null;
	isPartitionsHeads : Boolean = true;

	get components() {
		return app.component_configuration.productsComponents.filter(x => x.type ===
			'partitionsHeadPrestige');
	};

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	getWallThickness() {
		// TODO : DEHARDCODE
		return 0.05;
	};

	private computeMatrix(side : string) {
		const wdh = this.getWDH();
		const x = wdh.width;
		const y = wdh.height;
		const z = wdh.depth;
		void y;
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		const currentPartitionsHead = app.component_configuration.productsComponents.find(x => x.type ===
			'partitionsHeadPrestige' &&
			x.products.includes(product.id));
		if (!currentPartitionsHead) {
			throw STD.errors.user('No current partitions head found');
		}
		const boundingBox = currentPartitionsHead.boundingBox;
		if (!boundingBox) {
			throw STD.errors.user('Missing bounding box for head partition ' + currentPartitionsHead.SKU);
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part');
		}
		const layoutId = layoutCurrentOption.id;
		if (product.id === 'confort' || product.id === 'prestige') {
			if (side === 'right') {
				return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
			}
			if (layoutId === 'shape-no-wall') {
				return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
			} else if (layoutId === 'shape-back-left') {
				return (ViewerNS.Component.mtx(
					[ (x / 2), y - app.getFloorThickness(), -z / 2 - this.getWallThickness() / 2 ],
					[ 1, 1, 1 ],
					0
				));
			} else if (layoutId === 'shape-back') {
				return (ViewerNS.Component.mtx(
					[ (-x / 2), y - app.getFloorThickness(), -z / 2 - this.getWallThickness() / 2 ],
					[ 1, 1, 1 ],
					180
				));
			} else if (layoutId === 'shape-back-right') {
				return (ViewerNS.Component.mtx(
					[ (-x / 2), y - app.getFloorThickness(), -z / 2 - this.getWallThickness() / 2 ],
					[ 1, 1, 1 ],
					180
				));
			} else if (layoutId === 'shape-left-back-right') {
				return (ViewerNS.Component.mtx(
					[ (-x / 2) - this.getWallThickness() / 2, y - app.getFloorThickness(), z / 2 ],
					[ 1, 1, 1 ],
					270
				));
			} else {
				throw STD.errors.user('Unknown layoutId');
			}
		} else {
			throw STD.errors.user('Unknown product name');
		}
	};

	computeMatricesAndUpdateInfos() {
		this.computeMatrix('left');
		this.computeMatrix('right');
	};

	async insert() {
		const product = app.currentProduct;
		if (this.viewerNodeLeft || this.viewerNodeRight || !product || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		if (product.id === 'business' || product.id === 'siae') {
			return;
		}
		const trs = {
			left :  <Record<string, string>> {
				en : 'left',
				fr : 'gauche'
			},
			right : <Record<string, string>> {
				en : 'right',
				fr : 'droite'
			}
		};
		const category = app.viewer.categories.find(x => x.name === 'partitionsHeads');
		if (!category) {
			this.component_throwLibraryError('');
		}
		if (app.isReloading) {
			const instances = Array.from(ViewerComponent.self.safe.value.productInstances);
			const nodeLeft = instances.find(x => x.product.category === category && x.metadata.id === 'left');
			const nodeRight = instances.find(x => x.product.category === category && x.metadata.id === 'right');
			if (!nodeLeft && !nodeRight) {
				return;
			}
			if(nodeLeft){
				this.viewerNodeLeft = nodeLeft;
			}else{
				this.viewerNodeLeft = null;
			}
			if(nodeRight){
				this.viewerNodeRight = nodeRight;
			}else{
				this.viewerNodeRight = null;
			}
			{
				const product = app.currentProduct;
				if (!product) {
					throw STD.errors.user('No current product available!');
				}
				const layoutPart = product.getPart([ 'layout' ]);
				const layoutCurrentOption = layoutPart.currentOption;
				if (layoutCurrentOption) {
					this.computeMatricesAndUpdateInfos();
				}
			}
			return;
		}
		const partitionHeadsProductSchema = this.plannerCategory.products.find(x => x.SKU ===
			`@partitionsHead-${ product.id }`);
		if (!partitionHeadsProductSchema) {
			this.component_throwLibraryError('');
		}
		this.viewerNodeLeft =
			await partitionHeadsProductSchema.instantiate({
				rootLocalId : app.viewer.globalLocalId,
				appendType : 'insert',
				basketPart : [],
				basketUseDynamicTitleBinding : false,
				metadata : {
					id :           'left'
				}
		});
		this.viewerNodeLeft.setName(this.viewerNodeLeft.product.name + ' ' + trs.left[ app.currentLanguage ]);
		this.isPartitionsHeads = true;
		await this.update();
	};

	async update() {
		// update nodes matrices
		if (!this.viewerNodeLeft && !this.viewerNodeRight) {
			return;
		}
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		if (product.id === 'siae' || product.id === 'business') {
			return
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No current product available!');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			return;
		}
		const batch = [];
		if(this.viewerNodeLeft){
			batch.push({
				localId : this.viewerNodeLeft.localId,
				matrix :  this.computeMatrix('left')
			})
		}
		if(this.viewerNodeRight){
			batch.push({
				localId : this.viewerNodeRight.localId,
				matrix :  this.computeMatrix('right')
			})
		}
		await app.viewer.batch([
			[
				'setProductNodesInstancesMatrices', batch
			]
		]);
	};

	isEqual(tableau1 : ViewerComponent.TMatrix , tableau2 : ViewerComponent.TMatrix ) {
		if (tableau1.length !== tableau2.length) return false;

		return tableau1.every((value, index) => value === tableau2[index]);
	}

	async remove() {
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		if (!app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		if (this.viewerNodeLeft) {
			await this.viewerNodeLeft.delete();
			this.viewerNodeLeft = null;
		}
		if (this.viewerNodeRight) {
			await this.viewerNodeRight.delete();
			this.viewerNodeRight = null;
		}
		this.isPartitionsHeads = false;
	};

	getConfiguratorMenu() {
		return this;
	};

	override async component_initialize() {
		await super.component_initialize();
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		const partitionsHeadsComponent = this.components;
		const customImagesExtensions = {
			'partitionsHead-B' :      {
				configuratorGet : CM.PropertyOperation.CallOperation.create({
					type :          'call',
					componentPath : this.component_getPath(),
					propertyPath :  'getConfiguratorMenu',
					parameters :    [ 'unknown' ]
				}),
				customImages :    [
					{
						id :       'customImg',
						title :    { en : 'Add logo', fr : 'Ajouter un logo' },
						width :    1,
						height :   .5,
						mesh :     'TETE_DE_CLOISON_PRESTIGE.002.005',
						material : {
							name :          'custom_logo_enseigne_drapeau',
							configuration : {
								enabled :  'custom_logo_enseigne_drapeau',
								disabled : 'off'
							}
						}
					}
				]
			}
		};
		const viewerSKUMappingToInternalMapping : Record<string, string> = {
			'@partitionsHead-confort' :       'partitionsHead-B',
			'@partitionsHead-prestige' :      'partitionsHead-B',
		};
		(<STD.object.SetWritable<this, 'plannerCategory'>> this).plannerCategory = app.viewer.createCategory({
			name :        'partitionsHeads',
			menuActions : {
				edit :      true,
				delete :    false,
				rotate :    false,
				duplicate : false
			},
			products :    partitionsHeadsComponent.reduce<ViewerComponent.Product.IDescriptor[]>((a, c) => {
				for (const productSKU of c.products) {
					const dynamicSKU = `@partitionsHead-${ productSKU }`;
					const realSKU = viewerSKUMappingToInternalMapping[ dynamicSKU ];
					if (!realSKU) {
						this.component_throwLibraryError('');
					}
					app.viewer.productsExtensionById[ dynamicSKU ] = (<any> customImagesExtensions)[ realSKU ];
					a.push({
						SKU :   dynamicSKU,
						name :  c.translations[ '@name' ]?.[ app.currentLanguage ],
						nodes : [
							{
								SKU :                         <string> c.viewerComponentSKU,
								projectCode :                 <string> c.viewerProjectCode,
								localId :                     'global',
								parentLocalId :               'root',
								snappable :                   false,
								fixedPositionSetIds :         null,
								draggable :                   false,
								doNotListAsProductComponent : true,
								tracked :                     true,
								matrix :                      app.viewer.mtx(
									[ 0, 0, 0 ],
									[ 0, 0, 0 ],
									0
								)
							}
						]
					});
				}
				return a;
			}, [])
		});
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingPartitionsHeadsPrestigeComponentConfiguration
	)
	{
		configuration[ '@innerConfigurations' ] = {
			tutoContainer :   {
				'@innerConfigurations' : {
					imageInformation : <Image.Configuration> {
						URL : (app.clientAppParameters.app.assetsPath +
							'icon-infos.png').replace('CH1U0ZGKSI', 'E3GC4QDIZW').
									replace('XUJG0A2TF5', 'STAODAZNIS').
									replace('sam1_12345', 'STAODAZNIS')
					}
				}
			}
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory();
	};
};
export namespace NS {
	export const Component = StandingPartitionsHeadsPrestigeComponent;
	export type Component = StandingPartitionsHeadsPrestigeComponent;
	export type Configuration = IStandingPartitionsHeadsPrestigeComponentConfiguration;
}
import manifestXMLSource                   from './StandingPartitionsHeadsPrestige.xml';
import './StandingPartitionsHeadsPrestige.scss';

CM.declare({
	id :       'standing-partitionsHeadsPrestige',
	type :     StandingPartitionsHeadsPrestigeComponent,
	manifest : manifestXMLSource
});
